globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};
appCustomerSpace.Controllers.LocalManagement.FormSubmissionFunnel = appCustomerSpace.Controllers.LocalManagement.FormSubmissionFunnel || {};

appCustomerSpace.Controllers.LocalManagement.FormSubmissionFunnel.StartController = (function(superClass) {

  utils.extend(StartController, superClass);

  function StartController() {
    return StartController.__super__.constructor.apply(this, arguments);
  }

  $.extend(StartController.prototype, {
    init: function(){
      var $startButton = $('.btn-success');

      $('#accounts_business_form_submission_location_attributes_name').on('keyup', function(){
        $startButton.prop('disabled', $(this).val() == '')
      });

      return StartController.__super__.init.apply(this, arguments);
    }
  });

  return StartController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
